export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '',
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: '/',  // 开发模式也使用代理，避免跨域问题
    pro: '/'  // 生产环境使用相对路径，与前端同域
    // http://23.225.81.170:9800
    // dev: 'http://43.155.78.253:881/',
    // pro: 'http://43.155.78.253:881/'
  },
  /**
   * @description 需要加载的插件
   */
  plugin: {

  }
}
